import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RightDrawer from './RightDrawer';
import { useAuth } from '../auth/AuthContext';

export default function Header(){
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { current, logout, simulateGuestMode } = useAuth();

  const isGuestSimulation = simulateGuestMode;
  const isLoggedInView = Boolean(current) && !isGuestSimulation;
  const isDemoTester = current?.role === 'demo_tester';

  const goHomeOrDashboard = () => {
    if (isDemoTester) {
      navigate('/demoinfo');
    } else {
      navigate(isLoggedInView ? '/dashboard' : '/');
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const getGradeLabel = (grade) => {
    if (grade === 'grade_9') return '9. třída';
    return '5. třída';
  };

  return (
    <header className="header">
      <div className="brand">
        <button className="logo" onClick={goHomeOrDashboard} aria-label="MatikaMistr">
          <img 
            src="/logo4-matikamistr.png" 
            alt="MatikaMistr" 
            style={{ height: 40, borderRadius: '8px', display: 'block' }} 
          />
          <span style={{
            marginLeft: '8px',
            fontSize: '1.2rem',
            fontWeight: 700,
            color: 'var(--primary-color)'
          }}>
            MatikaMistr
          </span>
        </button>
        {isLoggedInView && current && current.grade && (
          <span style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            background: 'linear-gradient(135deg, var(--accent), #0891b2)',
            color: '#fff',
            padding: '3px 8px',
            borderRadius: '12px',
            letterSpacing: '0.3px',
            boxShadow: '0 2px 4px rgba(6,182,212,0.3)'
          }}>
            {getGradeLabel(current.grade)}
          </span>
        )}
      </div>

      <div className="controls">
        {isLoggedInView ? (
          <>
            <button className="btn ghost" onClick={() => navigate('/profile')} aria-label="Profil">
              Profil
            </button>
            <button className="btn ghost" onClick={handleLogout} aria-label="Odhlásit se">
              Odhlásit se
            </button>
            <button className="btn premium" onClick={() => navigate('/premium')} aria-label="Premium">
              Premium
            </button>
          </>
        ) : (
          <>
            <button className="btn ghost" onClick={() => navigate('/login')} aria-label="Přihlásit se">
              Přihlásit se
            </button>
            <button className="btn ghost" onClick={() => navigate('/register')} aria-label="Registrace">
              Registrace
            </button>
            <button className="btn primary" onClick={() => navigate('/login')} aria-label="Začít - přihlásit se">
              Začít
            </button>
          </>
        )}

        {isGuestSimulation && (
          <button className="btn ghost" onClick={() => navigate('/profile')} aria-label="Správa simulace hosta">
            Spravovat simulaci
          </button>
        )}

        {isGuestSimulation && (
          <span style={{ marginLeft: '12px', fontSize: '0.8rem', color: '#fef3c7', background: 'rgba(251, 191, 36, 0.1)', padding: '4px 8px', borderRadius: '999px', border: '1px solid rgba(251, 191, 36, 0.5)' }}>
            Simulace hosta
          </span>
        )}

        <button
          className="hamburger"
          aria-label="Přepnout menu"
          aria-expanded={open}
          onClick={()=>setOpen(!open)}
        >
          ☰
        </button>
      </div>

      <RightDrawer open={open} onClose={() => setOpen(false)} isAuthenticated={isLoggedInView} />
    </header>
  );
}
